import styled from "styled-components";

export const Btn = styled.button`
  background-color: #e85858;
  color: #ffffff;
  border: none;
  padding: 6px 20px;
  font-size: 14px;
  border-radius: 20px;
`;

export const BtnYellow = styled.button`
  background-color: #f2b137;
  color: #ffffff;
  border: none;
  padding: 6px 20px;
  font-size: 14px;
  border-radius: 20px;
  margin-right: 4px;
  margin-left: 12px;
`;

export const Item = styled.li`
  display: flex;
  width: 400px;
  background-color: #ffffff;
  align-items: center;
  padding: 6px 20px;
  border-radius: 12px;
`;

export const Text = styled.p`
  margin-left: 12px;
  margin-right: auto;
`;
